// Fila elegible (radio) de las piezas de promo: regalo, promo de venta, «Ninguna».
import type { ReactNode } from 'react';
import { Check } from 'lucide-react';
import { cn } from '@/lib/cn';

export interface ChoiceRowProps {
    checked: boolean;
    disabled?: boolean;
    onSelect: () => void;
    title: ReactNode;
    detail?: ReactNode;
    aside?: ReactNode;
}

export function ChoiceRow({ checked, disabled, onSelect, title, detail, aside }: ChoiceRowProps) {
    return (
        <button
            type="button"
            role="radio"
            aria-checked={checked}
            disabled={disabled}
            onClick={onSelect}
            className={cn(
                'flex w-full items-start gap-2.5 rounded-lg border px-3 py-2 text-left text-[13px] transition-colors',
                checked ? 'border-brand-accent bg-brand-accent/5' : 'border-border bg-card',
                disabled ? 'cursor-not-allowed opacity-50' : 'hover:border-brand-accent/60',
            )}
        >
            <span
                className={cn(
                    'mt-0.5 flex size-4 flex-none items-center justify-center rounded-full border',
                    checked ? 'border-brand-accent bg-brand-accent text-white' : 'border-border',
                )}
                aria-hidden
            >
                {checked && <Check className="size-3" />}
            </span>
            <span className="flex min-w-0 flex-1 flex-col">
                <span className="font-medium">{title}</span>
                {detail && <span className="text-[12px] text-muted-foreground">{detail}</span>}
            </span>
            {aside && <span className="flex-none text-[12px] text-muted-foreground">{aside}</span>}
        </button>
    );
}
